import { Brand, createBranded } from '@deltasierra/type-utilities';

export type ReportingSocialTemplatePublishFetchFailureId = Brand<
    number,
    'ReportingSocialTemplatePublishFetchFailureId'
>;
export const ReportingSocialTemplatePublishFetchFailureId =
    createBranded<ReportingSocialTemplatePublishFetchFailureId>();
